<template>
  <div style="padding: 20px; min-height: 630px; background-color: rgba(221, 225, 230, 1); border: solid 1px #ccc">
    <v-card>
      <div class="row mb-2 mt-0">
        <div class="col-md-12" v-if="list_access">
          <div class="col-md-12" style="background:white; elevation-0">
            <div class="row pt-5">
              <div class="col-md-2">
                <v-menu ref="desde_selected" v-model="desde_selected_open" :close-on-content-click="false"
                  :close-on-click="false" :return-value.sync="desde_selected" transition="scale-transition" offset-y
                  max-width="290px" min-width="auto" clearable>
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field v-model="desde_selected" label="Desde" prepend-icon="mdi-calendar" readonly
                      v-bind="attrs" v-on="on" class="pt-0 mt-0"></v-text-field>
                  </template>
                  <v-date-picker v-model="desde_selected" type="date" no-title scrollable>
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="desde_selected_open = false"> Cancel </v-btn>
                    <v-btn text color="primary" @click="$refs.desde_selected.save(desde_selected)"> OK </v-btn>
                  </v-date-picker>
                </v-menu>
              </div>

              <div class="col-md-2">
                <v-menu ref="hasta_selected" v-model="hasta_selected_open" :close-on-content-click="false"
                  :close-on-click="false" :return-value.sync="hasta_selected" transition="scale-transition" offset-y
                  max-width="290px" min-width="auto" clearable>
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field v-model="hasta_selected" label="Hasta" prepend-icon="mdi-calendar" readonly
                      v-bind="attrs" v-on="on" class="pt-0 mt-0"></v-text-field>
                  </template>
                  <v-date-picker v-model="hasta_selected" type="date" no-title scrollable>
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="hasta_selected_open = false"> Cancel </v-btn>
                    <v-btn text color="primary" @click="$refs.hasta_selected.save(hasta_selected)"> OK </v-btn>
                  </v-date-picker>
                </v-menu>
              </div>

              <div class="col-md-2">
                <v-combobox
                  v-model="document_type_selected"
                  :items="document_types"
                  item-text="text"
                  item-value="value"
                  label="Tipo de Documento"
                  clearable
                  class="pt-0 mt-0"
                ></v-combobox>
              </div>

              <div class="col-md-2">
                <v-combobox
                  v-model="action_selected"
                  :items="actions"
                  item-text="text"
                  item-value="value"
                  label="Acción"
                  clearable
                  class="pt-0 mt-0"
                ></v-combobox>
              </div>

              <div class="col-md-2">
                <v-text-field
                  v-model="document_number_selected"
                  label="N° Comprobante"
                  clearable
                  class="pt-0 mt-0"
                ></v-text-field>
              </div>

              <div class="col-md-2">
                <v-btn color="info" class="mt-0" @click="filter">Buscar</v-btn>
              </div>
            </div>
          </div>
        </div>
      </div>
    </v-card>

    <v-card v-if="list_access" class="mt-4">
      <v-card-title>
        <span class="text-uppercase">Logs de Documentos</span>
        <v-spacer></v-spacer>
        <v-text-field v-model="search" append-icon="search" label="Buscar" single-line hide-details></v-text-field>
      </v-card-title>
      <v-data-table 
        :headers="headers" 
        :items="list" 
        :search="search" 
        :loading="loading" 
        loading-text="Cargando..."
        :options="{
          descending: true,
          itemsPerPage: 15,
        }" 
        @pagination="updatePagination" 
        :footer-props="{
          itemsPerPageOptions: [5, 10, 15, 50, -1],
        }">
        <template v-slot:item="props">
          <tr>
            <td>{{ props.item.created_at }}</td>
            <td>{{ props.item.document_type }}</td>
            <td>{{ props.item.document_number }}</td>
            <td>
              <v-chip small :color="getActionColor(props.item.action_key)" dark>
                {{ props.item.action }}
              </v-chip>
            </td>
            <td>{{ props.item.user }}</td>
          </tr>
        </template>
        <template v-slot:no-results>
          <v-alert :value="true" color="error" icon="warning">
            {{ "Búsqueda sin resultados - " + search }}
          </v-alert>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import { formatUtils } from "@/libs/utils/formatUtils";
import GenericMixin from "@/mixins/GenericMixin.vue";
import RolMixin from "@/mixins/RolMixin.vue";
import { documentLogService } from "@/libs/ws/documentLogService";

export default {
  mixins: [GenericMixin, RolMixin],
  data() {
    return {
      formatUtils: formatUtils,
      parent: this,
      service: documentLogService,
      headers: [
        {
          text: "Fecha",
          align: "left",
          sortable: true,
          value: "created_at",
        },
        {
          text: "Tipo de Documento",
          align: "left",
          sortable: true,
          value: "document_type",
        },
        {
          text: "Número",
          align: "left",
          sortable: false,
          value: "document_number",
        },
        {
          text: "Acción",
          align: "left",
          sortable: true,
          value: "action",
        },
        {
          text: "Usuario",
          align: "left",
          sortable: true,
          value: "user",
        },
      ],
      list: [],
      desde_selected: new Date(new Date().getFullYear(), new Date().getMonth(), 1).toISOString().slice(0, 10),
      hasta_selected: new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0).toISOString().slice(0, 10),
      desde_selected_open: false,
      hasta_selected_open: false,
      document_type_selected: null,
      action_selected: null,
      document_number_selected: null,
      document_types: [
        { text: "Facturas", value: "voucher" },
        { text: "Gastos", value: "spent" },
        { text: "Cobranzas", value: "charge" },
        { text: "Pagos", value: "spent_payment" },
        { text: "Solicitudes de Pago", value: "payment_order" },
        { text: "Órdenes de Compra", value: "purchase_order" },
        { text: "Órdenes de Venta", value: "sale_order" },
        { text: "Remitos", value: "remito" },
        { text: "Remitos de Compra", value: "purchase_remito" },
        { text: "Órdenes de Producción", value: "production_order" },
        { text: "Movimientos Bancarios", value: "bank_movement" },
        { text: "Cheques", value: "check" },
        { text: "Movimientos de Tesorería", value: "tesoreria_movement" },
      ],
      actions: [
        { text: "Creado", value: "created" },
        { text: "Eliminado", value: "deleted" },
      ],
    };
  },
  mounted() {
    this.loadList(this.service, this.getFilterParams());
  },
  methods: {
    filter() {
      this.loadList(this.service, this.getFilterParams());
    },
    getFilterParams() {
      let params = {
        from: this.desde_selected,
        to: this.hasta_selected,
      };
      
      if (this.document_type_selected) {
        params.document_type = this.document_type_selected.value;
      }
      
      if (this.action_selected) {
        params.action = this.action_selected.value;
      }
      
      if (this.document_number_selected) {
        params.document_number = this.document_number_selected;
      }
      
      return params;
    },
    getActionColor(action) {
      const colors = {
        created: "success",
        deleted: "error",
      };
      return colors[action] || "grey";
    },
  },
};
</script>
